import styled, { css } from "styled-components";
import { Tooltip as TooltipPrimitive } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const Tooltip = styled(TooltipPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      z-index: ${tooltip.zIndex} !important;
    `;
  }}
`;

type ContainerProps = {
  $maxWidth: number | undefined;
};

export const Container = styled.div<ContainerProps>`
  ${({ $maxWidth }) => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      max-width: ${$maxWidth ? `${$maxWidth}px` : tooltip.maxWidth};
      border-radius: ${tooltip.radius};
      padding-top: ${tooltip.padding.top};
      padding-bottom: ${tooltip.padding.bottom};
      padding-left: ${tooltip.padding.left};
      padding-right: ${tooltip.padding.right.default};
      background: ${tooltip.backgroundColor};
    `;
  }}
`;
